module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="news-alert alert '+
((__t=( alertClass ))==null?'':__t)+
' fade show" role="alert">\n   '+
((__t=( message ))==null?'':__t)+
'\n</div>';
}
return __p;
};
